import { Col, GRID } from '../../components/custom';

export default function PCA()
{
    return (
        <Col id='PCA' className='usecase'>
            <Col className='banner'>
                <span className='title'>Use Case: Predicting Customer Churn Based on Feedback Sentiment</span>
            </Col>
            <Col className='section objective'>
                <span className='title'>Objective</span>
                <span className='descsmall'>To predict customer churn based on sentiment scores derived from customer feedback, identifying the most significant factors leading to customer attrition.</span>
            </Col>
            <Col className='section methodology'>
                <span className='title'>Methodology</span>
                <Col className='notTitle'>
                    <Col className='part'>
                        <span className='desc'>Approach: Logistic Regression (Binary Classification)</span>
                    </Col>
                    <Col className='part'>
                        <span className='desc'>Dependent Variables</span>
                        <ul>
                            <li className='descsmall'><strong>Churn</strong> (1 = Churned, 0 = Retained)</li>
                        </ul>
                    </Col>
                    <Col className='part'>
                        <span className='desc'>Independent Variables</span>
                        <ul>
                            <li className='descsmall'><strong>Sentiment Score</strong> (from customer feedback, using NLP to classify sentiment as positive, neutral, or negative)</li> 
                            <li className='descsmall'><strong>Frequency of Complaints</strong> (number of complaints reported by the customer)</li>
                            <li className='descsmall'><strong>Customer Support Interaction</strong> (number of interactions with customer support)</li>
                            <li className='descsmall'><strong>NPS Score</strong> (Net Promoter Score: score from 0-10)</li>
                        </ul>
                        <span className='descsmall'>Each independent variable is treated as a continuous or categorical input, and the model predicts the likelihood of a customer churning.</span>
                    </Col>
                </Col>
            </Col>
            <Col className='section results'>
                <span className='title'>Key Findings</span>
                <Col className='notTitle'>
                    <Col className='part'>
                        <GRID className='_4x5'>
                            <span className='descsmall bold'>Driver</span>
                            <span className='descsmall bold'>Odds Ratio</span>
                            <span className='descsmall bold'>P-value</span>
                            <span className='descsmall bold'>Interpretation</span>
                            <span className='descsmall bold left'>Sentiment Score (Negative)</span>
                            <span className='descsmall'>3.20</span>
                            <span className='descsmall'>0.001</span>
                            <span className='descsmall left'>Strong predictor — customers with negative sentiment are 3.2 times more likely to churn.</span>
                            <span className='descsmall bold left'>Frequency of Complaints</span>
                            <span className='descsmall'>2.50</span>
                            <span className='descsmall'>0.002</span>
                            <span className='descsmall left'>Significant — customers who frequently complain are 2.5 times more likely to churn.</span>
                            <span className='descsmall bold left'>Customer Support Interaction</span>
                            <span className='descsmall'>1.80</span>
                            <span className='descsmall'>0.045</span>
                            <span className='descsmall left'>Moderate impact — increased customer support interactions correlate with a higher likelihood of churn.</span>
                            <span className='descsmall bold left'>NPS Score (Detractors)</span>
                            <span className='descsmall'>4.50</span>
                            <span className='descsmall'>0.000</span>
                            <span className='descsmall left'>Very significant — detractors (score 0-6) are 4.5 times more likely to churn compared to promoters.</span>
                        </GRID>
                    </Col>
                    <Col className='part'>
                        <span className='desc'>Insightful Takeaway:</span>
                        <span className='descsmall'><strong>Negative sentiment and high frequency of complaints</strong> are the strongest indicators of customer churn. Customers who express negative sentiment are significantly more likely to leave the company, as are those who have a high volume of complaints. Additionally, <strong>NPS score</strong> shows a strong correlation, with detractors being much more likely to churn. This analysis highlights the importance of monitoring sentiment and addressing customer complaints promptly to prevent churn.</span>
                    </Col>
                </Col>
            </Col>
        </Col>
    )
}